(function () {
  'use strict';
  if (window.__artmereWhatsAppAssistanceBound) return;
  window.__artmereWhatsAppAssistanceBound = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-artmere-whatsapp-assistance]');
    if (!link) return;

    // Rebuild from the current page/form at activation time; theme variant changes
    // replace the product form and URL without reloading the document.
    var pageUrl = new URL(window.location.pathname, window.location.origin);
    var placement = link.getAttribute('data-placement');
    var variantId = '';
    if (placement === 'pdp_buybox') {
      var form = document.getElementById(link.getAttribute('data-form-id'));
      var input = form && form.querySelector('input[name="id"]');
      if (input && /^\d+$/.test(input.value)) {
        variantId = input.value;
        pageUrl.searchParams.set('variant', variantId);
      }
    }

    try {
      var destination = new URL(link.href);
      destination.searchParams.set('text', link.getAttribute('data-message') + '\n\n' + pageUrl.href);
      link.href = destination.href;
    } catch (error) {
      // The server-rendered, encoded wa.me link remains a functional fallback.
    }

    if (typeof window.artmerePublishMeasurementEvent === 'function') {
      window.artmerePublishMeasurementEvent('artmere_whatsapp_assistance_click', {
        surface: 'whatsapp_assistance',
        placement: placement,
        page_type: placement === 'pdp_buybox' ? 'product' : 'page',
        product_id: link.getAttribute('data-product-id') || '',
        product_handle: link.getAttribute('data-product-handle') || '',
        variant_id: variantId,
        current_url: pageUrl.href
      }, String(Date.now()) + ':' + String(event.timeStamp) + ':' + Math.random());
    }
    // No preventDefault, await, network request or navigation delay.
  }, true);
}());
